var map = {
	"./black/renwutongbu.png": "RPj0",
	"./blue/renwutongbu.png": "IO6u",
	"./white/renwutongbu.png": "uHUr"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2EuZ";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/renwutongbu\.png$
// module id = 2EuZ
// module chunks = 24